import {
  useState,
} from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';

import {
  shallowEqual,
  useDispatch,
  useSelector,
} from 'react-redux';

import {
  coreActions,
  coreSelectors,
} from '@gymcloud/core';

import {
  AddCardForm,
} from 'web-components';
import config from 'web-config';

import {
  Flex,
  Text,
} from 'web-styled';

import * as S from '../styled';

const stripePromise = loadStripe(config.stripe.key);

const mapState = state => ({
  defaultCardId: coreSelectors.defaultCardIdSelector(state),
  paymentMethods: coreSelectors.getResourceMappedList(
    'paymentMethods',
  )(state),
});

const PaymentMethod = () => {
  const {
    defaultCardId,
    paymentMethods,
  } = useSelector(mapState, shallowEqual);
  const dispatch = useDispatch();
  const [cardFormIsVisible, setCardFormVisible] = useState(false);

  const onSetDefaultPaymentMethod = (method: any) => {
    dispatch(
      coreActions.requestSetDefaultPaymentMethod({
        id: method.id,
      }),
    );
  };

  const handleAddCard = (res: any, actions: any) => {
    dispatch(
      coreActions.requestCreatePaymentMethod({
        body: {
          id: res.paymentMethod.id,
        },
        callbacks: {
          ...actions,
          onSuccess: () => {
            setCardFormVisible(false);
          },
        },
      }),
    );
  };

  return (
    <Flex width="100%" column spacing={5}>
      <Text size="16px" weight="700">
        Payment Method
      </Text>
      <Text>
        Pay with card
      </Text>
      <Flex
        column
        width="100%"
      >
        {paymentMethods.map(m => (
          <Flex
            key={m.id}
            width="100%"
            align="center"
            spacing={5}
            clickable
            onClick={() => onSetDefaultPaymentMethod(m)}
          >
            <S.CheckCircle
              isDefault={m.id === defaultCardId}
            />
            <Text
              size="13px"
              color="#8e8e8e"
            >
              ending in
              {' '}
              {m.card.last4}
            </Text>
          </Flex>
        ))}
      </Flex>
      {cardFormIsVisible ? (
        <Flex
          width="100%"
          padding="10px 0"
          column
        >
          <hr />
          <Elements stripe={stripePromise}>
            <AddCardForm
              submitText="Add Card"
              onCancel={() => setCardFormVisible(false)}
              onSuccess={handleAddCard}
            />
          </Elements>
        </Flex>
      ) : (
        <S.LinkButton onClick={() => setCardFormVisible(true)}>
          +Add new card
        </S.LinkButton>
      )}
    </Flex>
  )
}

export default PaymentMethod;
